<template>
  <!-- 修改需要考虑同步，privacy-policy-terms-of-use pdv-reject-refund-policy.html -->
  <div class="refund-explain">
    <div class="condition">
      在所有签证商品中，一旦发生签证拒签，签证申请人需满足以下对应产品要求的全部条件，即可享受拒签退全款服务：
    </div>
    <div class="part">
      <div class="title">美国、加拿大、申根、英国、澳大利亚、新西兰</div>
      <div class="content">
        <ul>
          <li>无任何国家拒签记录。</li>
          <li>无不良出境记录（比如护照DT、签证逾期停留等）。</li>
          <li>申请人资料完整且无虚假。</li>
          <li>有稳定的收入证明或者工作证明；</li>
          <li>
            申请人在下单前必须包含至少1次OECD国家（包含澳大利亚，比利时，丹麦，法国，德国，希腊，爱尔兰，冰岛，
            意大利，卢森堡，荷兰，
            新西兰，挪威，葡萄牙，西班牙，瑞典，瑞士，英国，美国，加拿大，奥地利，芬兰）的个签出境记录，或2次及以上个签出境记录（必须至少包含日本/韩国1次）（单身未婚女性且单独出行，不支持拒签退全款服务）。
          </li>
        </ul>
      </div>
    </div>
    <div class="part">
      <div class="title">
        除美国、加拿大、英国、澳大利亚、新西兰和申根签证国家外的其他国家
      </div>
      <div class="content">
        <ul>
          <li>无任何国家拒签记录。</li>
          <li>
            无境内外犯罪记录或不良出国记录(境外滞留，入境港澳护照印有DT章等)。
          </li>
          <li>申请人资料完整且无虚假。</li>
        </ul>
      </div>
    </div>
    <div class="part">
      <div class="title">补充说明</div>
      <div class="content">
        <ul>
          <li>
            因个人原因（例如：领馆或签证中心电话调查未通过、不配合补资料等）造成的拒签不退款。
          </li>
          <li>要求撤销签证申请所导致的拒签不退款。</li>
          <li>由于领馆原因造成延迟出签进而影响行程的不在保障范围内。</li>
          <li>
            拒签退全款赔付仅包含熊猫签证的签证下单费用，赔付不包含除此之外的任何其他费用（例如，客人自身的机酒费用）。
          </li>
          <li>
            仅支持中国因私普通护照持有人，不支持中国因公护照和其它国家护照持有人。
          </li>
          <li>需在系统拒签状态更新后一个月内申请赔付，超时不受理。</li>
        </ul>
      </div>
    </div>
    <div class="part">
      <div class="title">赔付流程</div>
      <div class="content">
        <ul>
          <li>
            满足上述拒签退全款条件，在签证申请被大使馆或领事馆拒绝后，可享签证订单全额无损退款。
          </li>
          <li>
            确定被拒签后，请联系您的专属客服并告知订单信息，客服将在7个工作日内进行核实，如符合退款规则，会及时安排退款处理。
          </li>
          <li>若同一笔订单有2人及以上办签，只退被拒签用户的费用。</li>
        </ul>
      </div>
    </div>

    <div class="part">
      <div class="title">以下情况⽀持全额退款</div>
      <div class="content">
        <ul>
          <li>
            签证申请⼈资料未完成预审时，可申请全额退款（不包含快递费⽤）；
          </li>
          <li>
            签证申请⼈被拒签且符合拒签退全款条件时，可享受拒签退全款服务（不包含快递费⽤）。
          </li>
        </ul>
      </div>
    </div>

    <div class="part">
      <div class="title">以下情况不⽀持退款</div>
      <div class="content">
        <ul>
          <li>签证申请⼈的资料已递交使馆后，不⽀持申请退款；</li>
          <li>
            部分签证国家领馆需要预先缴费后送签（美国、英国、丹⻨、冰岛、泰国），预审完毕后实际订单已缴
            纳使馆签证费⽤时，不⽀持申请退款。
          </li>
          <li>
            因战争、灾难、疫情、政府禁令、国际突发事件或其他不可抗力原因而造成申请人拒签的，不支持申请退款。
          </li>
        </ul>
      </div>
    </div>

    <div class="part">
      <div class="title">以下情况⽀持部分退款</div>
      <div class="content">
        <ul>
          <li>
            签证申请⼈的资料尚未递交使馆或缴费时，申请⼈主动更改同⼀⽬的地的签证商品时，可根据更换前后
            的商品差额进⾏部分退款；
          </li>
          <li>
            签证申请⼈实际出签结果与订单签证需求不完全⼀致时，可根据签证差异进⾏部分退款；（如：多次⼊
            境的签证商品，使馆实际出签为单次⼊境时，可根据商品差异进⾏部分退款）；
          </li>
          <li>
            签证申请⼈成功出签后，若收到我司寄出的出签快递为到付件，可提供订单号、快递单号、付款凭证申
            请针对快递费⽤退款。
          </li>
        </ul>
      </div>
    </div>

    <div class="part">
      <div class="title">关于退改时已产⽣的签证服务费⽤</div>
      <div class="content">
        若熊猫签证已为签证申请⼈提供了签证办理服务如资料审核、使馆送签、使馆预约等服务，申请⼈主动申
        请退款时，将收取订单实际⽀付⾦额⼀定⽐例的服务费⽤，《服务收费标准》如下：
      </div>
    </div>

    <table border="1" cellspacing="0">
      <thead>
        <tr>
          <td>办签状态</td>
          <td>退改服务费</td>
          <td>服务费⽤说明（服务费计算基数=订单实际付款⾦额/申请⼈个数）</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>等待预审</td>
          <td>/</td>
          <td>申请⼈资料未审核时，退改不产⽣服务费。</td>
        </tr>
        <tr>
          <td>预审不通过</td>
          <td>10%</td>
          <td>
            申请⼈资料预审不通过达到三次以上时，取消办理将产⽣10%的服务费。
          </td>
        </tr>
        <tr>
          <td>等待送签</td>
          <td>10%</td>
          <td>
            申请⼈资料审核通过，签证不涉及赴馆并处于等待送签状态下，取消办理将产⽣
            10%的服务费。
          </td>
        </tr>
        <tr>
          <td>使馆等待预约</td>
          <td>50%</td>
          <td>
            申请⼈资料审核通过，签证涉及赴馆并处于等待预约时，若办签⼯作⼈员已⽀付使
            馆预约费⽤，申请⼈取消办理将产⽣50%的服务费。
          </td>
        </tr>
        <tr>
          <td>使馆预约成功</td>
          <td>70%</td>
          <td>
            申请⼈资料审核通过，签证涉及赴馆并已预约成功时，申请⼈取消办理将产⽣70%
            的服务费。
          </td>
        </tr>
      </tbody>
    </table>

    <div class="part">
      <div class="title">退款须知</div>
      <div class="content">
        <ul>
          <li>订单全额退款仅退还订单签证商品服务的实际⽀付⾦额；</li>
          <li>订单全额退款不包含⽤户已⽀付的顺丰上⻔取件费⽤；</li>
          <li>
            订单申请全额或部分退款的签证资料回寄快递费⽤，由申请⼈⾃⾏承担。
          </li>
        </ul>
      </div>
    </div>

    <div class="part">
      <div class="title">退款时效</div>
      <div class="content">
        <ul>
          <li>
            ⽀付时间距今三个⽉内的订单，退款时间为1-2个⼯作⽇，按原⽀付路径退款；
          </li>
          <li>
            ⽀付时间距今超三个⽉的订单，需提供接收退款的⽀付宝账号及真实姓名，退款时间为1个⼯作⽇。也
            可以提供银⾏卡号进⾏退款，退款时间为3-5个⼯作⽇。
          </li>
        </ul>
      </div>
    </div>

    <div class="part">
      签证申请人确认已对上述规则说明进行阅读，充分理解其含义且确认不存在歧义或不明确之处，并已就可能不明确的规则联系客服进行咨询。拒签退全款赔付服务由深圳市六六六网络服务有限公司享有解释权，签证申请人确认并同意接受上述服务规则说明，以享受相关服务。
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  created() {
    utils.setTitle('拒签退全款及商品退改说明');
  },
};
</script>

<style lang="less" scoped>
.refund-explain {
  color: #444444;
  background: #ffffff;
  padding: 0.3rem 0.1rem;
  width: 100%;
  box-sizing: border-box;
  .condition {
    font-size: 0.14rem;
    line-height: 0.22rem;
  }
  .part:not(.first) {
    margin-top: 0.28rem;
  }
  .title {
    height: 0.16rem;
    line-height: 0.16rem;
    font-size: 0.16rem;
    color: #333333;
    font-family: PingFangSC-Medium;
    font-weight: normal;
    font-stretch: normal;
    // border-left: 0.03rem solid #ff5a60;
    padding-left: 0.1rem;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      border: 0;
      width: 0.03rem;
      background: #ff5a60;
      border-radius: 0.015rem;
      height: 100%;
      left: 0;
    }
  }
  .content {
    margin-top: 0.16rem;
    padding-left: 0.11rem;
    .explain {
      font-size: 0.14rem;
      line-height: 0.22rem;
    }
    ul {
      margin-top: 0.08rem;
      padding-left: 0.15rem;
      counter-reset: index;
      li {
        counter-increment: index;
        font-size: 0.14rem;
        line-height: 0.24rem;
        position: relative;
        &::before {
          content: counter(index) '.';
          position: absolute;
          left: -0.14rem;
        }
      }
    }
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #444;
  }
  table {
    margin-top: 0.28rem;
    border-color: #444;
    border-collapse: collapse;
    thead {
      background-color: #d5d5d5;
      color: #000;
      td {
        padding: 0.1rem;
      }
    }
    tbody {
      tr {
        td {
          padding: 0.1rem;
          text-align: center;
        }
      }
    }
  }
}
</style>
